import React, { useState } from "react";
import { motion } from "motion/react";

const VARIANTS = {
  primary: {
    defaultBg: "#005eb8",
    hoverBg: "#0071DE",
    rippleRgb: "0, 113, 222",
  },
  success: {
    defaultBg: "#3E826D",
    hoverBg: "#52B894",
    rippleRgb: "82, 184, 148",
  },
  danger: {
    defaultBg: "#DA291C",
    hoverBg: "#E8554A",
    rippleRgb: "232, 85, 74",
  },
};

/**
 * Pill button with hover color transition, scale, and pulsing ring (motion).
 * @param {'primary'|'success'|'danger'} variant
 */
export function RippleHoverButton({
  variant = "primary",
  onClick,
  children,
  className = "",
  disabled = false,
  "data-testid": dataTestId,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const { defaultBg, hoverBg, rippleRgb } = VARIANTS[variant];

  return (
    <motion.button
      type="button"
      disabled={disabled}
      data-testid={dataTestId}
      className={`relative inline-flex items-center justify-center overflow-visible border-0 px-[10px] py-[10px] text-[14px] font-medium leading-[20px] text-white outline-none ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"} ${className}`}
      style={{
        backgroundColor: defaultBg,
        borderRadius: 33,
        minWidth: 121,
      }}
      onHoverStart={() => !disabled && setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      whileHover={
        disabled
          ? undefined
          : {
              backgroundColor: hoverBg,
              scale: 1.05,
            }
      }
      transition={{
        backgroundColor: { duration: 0.3 },
        scale: { duration: 0.3 },
      }}
      onClick={onClick}
    >
      <motion.span
        className="pointer-events-none absolute inset-0"
        style={{ borderRadius: 33 }}
        animate={
          isHovered
            ? {
              boxShadow: [
                `0 0 0 0px rgba(${rippleRgb}, 0.6)`,
                `0 0 0 20px rgba(${rippleRgb}, 0)`,
              ],
            }
            : {
              boxShadow: `0 0 0 0px rgba(${rippleRgb}, 0)`,
            }
        }
        transition={{
          duration: 1.5,
          repeat: isHovered ? Infinity : 0,
          ease: "easeOut",
        }}
      />
      <span className="relative z-10 whitespace-nowrap">{children}</span>
    </motion.button>
  );
}
